export const SITE_URL: string = import.meta.env.VITE_SITE_URL || 'https://usfanslink.beauty';
export const SITE_NAME = 'USFansLink';
export const SITE_LOGO = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}